import { getCommonWidget } from "../../dashWidgetHelper";
import {
  commonWidgets,
  PROFUTURO_ORANGE,
  PROFUTURO_RED_1,
  PROFUTURO_GREEN_1,
} from "../commonWidgetsProfuturo";

// IDs de momentos críticos (staticDashboards.ts)
const CM_CHAT_HUMANO = 10370
const CM_CHAT_ALBA = 10351
const CM_SUCURSAL = 13604

export default {
  title: 'Close the loop Dashboard',
  description: 'Close the loop Dashboard',
  backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI) => [
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMediumSiNo',
      title: '¿Pudiste resolver tu consulta/inquietud?',
      helpText: '¿Pudiste resolver tu consulta/inquietud?',
      position: [0, 0],
      size: [2, 2],
      indicator: 'close_the_loop_si_no',
      extras: {
        groupNameFormat: 'description',
        formula: 'count-text'
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'countNumberSemicircle',
      title: 'Satisfacción',
      position: [2, 0],
      size: [2, 2],
      indicator: 'close_the_loop_csat',
      helpText: '¿Qué tan satisfecho estás con la llamada que recibiste de Profuturo?',
      historic: {
        type: 'line',
        formula: 'wavg',
        formulaConfig: 'wavg-top',
      }
    }),

    // ---- Chat Humano (10370) ----
    {
      title: 'Chat humano',
      position: [0, 2],
      size: [4, 1],
      type: 'label',
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMediumSiNo',
      title: 'Efectividad',
      position: [0, 3],
      size: [2, 2],
      helpText: '¿Pudiste resolver todo lo que necesitabas?',
      indicator: 'chat_humano_l_pregunta_12',
      criticalMomentInclude: [CM_CHAT_HUMANO],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'countNumberSemicircle',
      title: 'Satisfacción',
      position: [2, 3],
      size: [2, 2],
      indicator: 'chat_humano_l_pregunta_2',
      criticalMomentInclude: [CM_CHAT_HUMANO],
      helpText: '¿Qué tan satisfecho estás con tu interacción con el asesor de Profuturo a través de chat?',
      historic: {
        type: 'line',
        formula: 'wavg',
        formulaConfig: 'wavg-top',
      }
    }),

    // ---- Chat Alba (10351) ----
    {
      title: 'Chat Alba',
      position: [0, 5],
      size: [4, 1],
      type: 'label',
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMediumSiNo',
      title: 'Efectividad',
      position: [0, 6],
      size: [2, 2],
      helpText: '¿Pudiste resolver todo lo que necesitabas?',
      indicator: 'albapregunta_8',
      criticalMomentInclude: [CM_CHAT_ALBA],
      extraConfigs: {
        colors: {
          3: PROFUTURO_ORANGE,
          2: PROFUTURO_RED_1,
          1: PROFUTURO_GREEN_1,
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'countNumberSemicircle',
      title: 'Satisfacción',
      position: [2, 6],
      size: [2, 2],
      indicator: 'albapregunta_2',
      criticalMomentInclude: [CM_CHAT_ALBA],
      helpText: 'Para comenzar, ¿qué tan satisfecho estás con tu interacción con Alba?',
      historic: {
        type: 'line',
        formula: 'wavg',
        formulaConfig: 'wavg-top',
      }
    }),

    // ---- Sucursal (13604) ----
    // No existe "canal seguro y confiable"; se usa Satisfacción (equivalente al 2º widget de CTL)
    {
      title: 'Sucursal',
      position: [0, 8],
      size: [4, 1],
      type: 'label',
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMediumSiNo',
      title: 'Resolución del Trámite',
      position: [0, 9],
      size: [2, 2],
      helpText: 'En tu última visita, ¿Se resolvió tu trámite?',
      indicator: 'sucursal_pregunta_27',
      criticalMomentInclude: [CM_SUCURSAL],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'countNumberSemicircle',
      title: 'Satisfacción',
      position: [2, 9],
      size: [2, 2],
      indicator: 'sucursal_pregunta_2',
      criticalMomentInclude: [CM_SUCURSAL],
      helpText: '¿Qué tan satisfecho estás con tu visita a la sucursal?',
      historic: {
        type: 'line',
        formula: 'wavg',
        formulaConfig: 'wavg-top',
      }
    }),
  ]
} as DasboardConfig
